import axios from 'axios'
import qs from 'qs'

const httpRequest = axios.create({
    timeout: 1000 * 120,
    withCredentials: true
})
axios.defaults.timeout = 120000

// ajax请求方法封装
const http = {
    getOssConf(url, params, success, fail) {
        let headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        httpRequest({
            url: process.env.MQTT_API + url,
            method: 'get',
            data: null,
            headers: headers
        }).then((callback) => {
            this.handle(callback, success, fail)
        }).catch((error) => {
            if (fail !== null) {
                fail(error)
            }
            console.log(error)
        })
    },
    get (url, params, success, fail) {
        this.doAjax(url + '?' + qs.stringify(params), 'get', null, success, fail)
    },
    post (url, params, success, fail = null, contentType = 'form') {
        let headers = null
        if (contentType !== 'form') {
            headers = {
                'Content-Type': 'application/json'
            }
            params = JSON.stringify(params)
        } else {
            headers = {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
            params = qs.stringify(params)
        }
        this.doAjax(url, 'post', params, success, fail, headers)
    },
    /**
     * ajax请求方法
     * @param url
     * @param method
     * @param params
     * @param success
     * @param fail
     * @param headers
     */
    doAjax (url, method, params, success, fail = null, headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
    }) {
        httpRequest({
            url: process.env.BASE_API + url,
            method: method,
            data: params,
            headers: headers
        }).then((callback) => {
            this.handle(callback, success, fail)
        }).catch((error) => {
            if (fail !== null) {
                fail(error)
            }
            console.log(error)
        })
    },
    /**
     * 响应体处理
     * @param callback
     */
    handle (callback, success, fail) {
        let code = callback.data.code
        if (code === 200) {
            success(callback.data)
        } else {
            if (fail !== null) {
                fail(callback.data)
            }
        }
    }
}

export default http



// WEBPACK FOOTER //
// ./src/utils/httpRequest.js